export default __webpack_public_path__ + "static/media/shuffle.c1f44ecc.svg";